export default function FeatureCard({ icon: Icon, title, description }) {
  return (
    <article className="mk-feature-card">
      <div className="mk-feature-card-icon" aria-hidden="true">
        {Icon ? <Icon size={22} strokeWidth={1.9} /> : null}
      </div>
      <h3 className="mk-feature-card-title">{title}</h3>
      <p className="mk-feature-card-desc">{description}</p>
    </article>
  );
}
